import { Toast } from 'vant';

Toast.setDefaultOptions({ duration: 3000 });
Toast.setDefaultOptions('fail', {
  icon: require('@/assets/img/toast-icon-fail.png'),
});
